import { gql } from '@apollo/client'

export const ROOMTYPE_FACILITIES_QUERY = gql`
  query GetRoomTypeFacilities($propertyCode: String!, $roomTypeCode: String!) {
    getRoomTypeFacilities(
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
    ) {
      label
      facilities {
        label
        value
        id
        description
        selected
      }
    }
  }
`
